<template>
    <user-box>
        <template slot="buttons">
            <button
                v-t="'save'"
                :class="{ 'is-loading': loadingData }"
                :disabled="!personalDataChanged"
                class="button is-primary"
                @click="saveUserData"
            />
        </template>
        <template slot="content">
            <div class="columns is-mobile">
                <div class="column">
                    <user-profile-personal-data :user-data="userProfile" />
                    <user-profile-school-data />
                </div>
                <div class="column is-4">
                    <div v-if="!hasImage && !addProfileImage">
                        <figure class="image is-64x64" style="margin: auto">
                            <img
                                :src="personalData.avatar"
                                referrerPolicy="no-referrer"
                                class="is-rounded"
                            />
                        </figure>
                        <button
                            v-t="'creation.image'"
                            class="button is-primary is-outlined"
                            @click="addProfileImage = true"
                        ></button>
                    </div>
                    <project-configuration-image
                        v-if="hasImage || addProfileImage"
                        :image.sync="userProfile.image"
                        :can-edit="true"
                    />
                </div>
            </div>
        </template>
    </user-box>
</template>

<script>
import UserBox from '@/components/UserBox';
import UserProfilePersonalData from '@/components/UserProfilePersonalData';
import UserProfileSchoolData from '@/components/UserProfileSchoolData';
import { isEqual } from 'underscore';
import ProjectConfigurationImage from '@/components/ProjectConfigurationImage';

export default {
    components: {
        UserBox,
        UserProfilePersonalData,
        UserProfileSchoolData,
        ProjectConfigurationImage,
    },
    data() {
        return {
            loadingData: false,
            userProfile: {},
            addProfileImage: false,
        };
    },
    computed: {
        user() {
            return this.$store.getters.user;
        },
        personalData() {
            return this.$store.getters.personalData;
        },
        personalDataChanged() {
            return !isEqual(this.userProfile, this.$store.getters.personalData);
        },
        hasImage() {
            console.log(this.$store.getters.personalData.image);
            if (this.$store.getters.personalData.image.url) {
                return true;
            }
            return false;
        },
    },
    watch: {
        personalData: {
            handler: function () {
                this.loadingData = false;
                this.userProfile = JSON.parse(
                    JSON.stringify(this.$store.getters.personalData)
                );
            },
            immediate: true,
        },
    },
    methods: {
        async saveUserData() {
            this.loadingData = true;
            if (!this.userProfile.validated) {
                if (this.userProfile.school._id) {
                    this.userProfile.validated = true;
                }
            }
            console.log(this.userProfile.image.url, this.addProfileImage);
            if (!this.userProfile.image.url) {
                this.addProfileImage = false;
            }
            return this.$store.dispatch('updateProfile', this.userProfile);
        },
    },
};
</script>

<style>
.field-label {
    text-align: left;
}
.field-body {
    flex-grow: 12;
}
</style>
